import { Processing, Sticky, StickyContainer, Tabs } from "@wg/wows-react-uikit";
import ClansRating from "fe2/Containers/ContainerBaseClansRating";
import * as React from "react";
import dwhExport from '~/dwhExport';
import { t } from "../../helpers/localization";
import ClanBattlesHistory from "./ClanBattlesHistory/ClanBattlesHistory";
import ClanBattlesInfoPage from "./ClanBattlesInfoPage/ClanBattlesInfoPage";
import ClanBattlesRulesPage from "./ClanBattlesRulesPage/ClanBattlesRulesPage";
import styles from "./ViewClanBattles.scss";

export type ViewClanBattles_Props = {
  selectedTab: number;
  clanId: number;
  clanBattlesInfoContent: any;
  clanData: any;
  battlesList: any;
  isError: boolean;
  isFetching: boolean;
  selectedBattle: any;
  wowsLadder: any;
  seasonType: string;
  teamNumber: number;
  hasBattles: boolean;
  urlParams: any;

  setSelectedTab: (selectedTab: string) => void;
  navigateToRecommendations: () => void,
  onClickBattle: (battleId: number) => void;
  getClanBattles: () => void;
  setSelectedTeamNumber: (teamNumber: number) => void;
};

class ViewClanBattles extends React.PureComponent<ViewClanBattles_Props, any> {

  componentDidMount() {
    dwhExport.send('clan_battles.open_page') 
  }
  
  renderTab() {
    switch (parseInt(this.props.selectedTab, 10)) {
      case 0:
        {
          if (this.props.hasBattles) {
            return (
              <ClanBattlesHistory
                clanId={this.props.clanId}
                clanData={this.props.clanData}
                battlesList={this.props.battlesList}
                isError={this.props.isError}
                isFetching={this.props.isFetching}
                selectedBattle={this.props.selectedBattle}
                wowsLadder={this.props.wowsLadder}
                seasonType={this.props.seasonType}
                onClickBattle={this.props.onClickBattle}
                reload={this.props.getClanBattles}
                teamNumber={this.props.teamNumber}
                setSelectedTeamNumber={this.props.setSelectedTeamNumber}
              />
            )
          } else {
            return (
              <ClanBattlesInfoPage
                clanId={this.props.clanId}
                navigateToRecommendations={this.props.navigateToRecommendations}
              />
            )

          }
        }
      case 1:
        {
          return <ClansRating urlParams={this.props.urlParams} />;
        }
      case 2:
        {
          return <ClanBattlesRulesPage />;
        }
      default:
        {
          return null;
        }

    }
  }

  setSelectedTab = (selectedTab: string | number) => {
    this.props.setSelectedTab(`${selectedTab}`);
  };

  render() {

    let tabs = [{ value: 0, content: t('Клановые бои') }, { value: 1, content: t('Рейтинг кланов') }];

    if (this.props.clanId) {
      tabs.push({ value: 2, content: t('Правила') });
    }

    return <StickyContainer id={'stickyClanBattles'}>
      <div className={styles.wrapper}>
        <Sticky usedStickyContainerId={'stickyClanBattles'} isActive={true}>
          <div className={styles.tabsNavigation}>
            <Tabs isUppercase smallHeight tabSelected={parseInt(this.props.selectedTab, 10)} tabs={tabs} onToggleTab={this.setSelectedTab} />
          </div>
        </Sticky>
        {this.props.isFetching ? null : this.renderTab()}
        <Processing isFetching={this.props.isFetching} label={''} />
      </div>
    </StickyContainer>;
  }
}


export default ViewClanBattles;